import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Interval, Axis, Tooltip, Coordinate, Legend } from "bizcharts";
import DataSet from "@antv/data-set";
import DownloadButton from "../Common/DownloadButton";

const DodgeBarCommodity = (props) => {
  const [data, setData] = useState([]);

  const filter = props.filter;

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        setData(
          results.data.filter((d) => d["Food commodity"] === props.filter)
        );
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, [filter]);

  let transform = [];
  data.forEach((d) => {
    const a = {
      label: "≤MRL",
      "≤MRL": d["% Between Quant Lim and LL 6 years ago"],
      year: "2018",
    };
    const b = {
      label: "≤MRL",
      "≤MRL": d["% Between Quant Lim and LL 3 years ago"],
      year: "2021",
    };
    const c = {
      label: "≤MRL",
      "≤MRL": d["% between LOQ and LL samples"],
      year: "2024",
    };
    const p = {
      label: ">MRL",
      ">MRL": d["% Above LL 6 years ago"],
      year: "2018",
    };
    const e = {
      label: ">MRL",
      ">MRL": d["% Above LL 3 years ago"],
      year: "2021",
    };
    const f = {
      label: ">MRL",
      ">MRL": d["% Above LL samples"],
      year: "2024",
    };

    transform = transform.concat([a, b, c, p, e, f]);
  });

  const ds = new DataSet();
  const dv = ds.createView().source(transform);
  dv.transform({
    type: "fold",
    fields: ["≤MRL", ">MRL"],
    key: "type",
    value: "value",
  });

  const [canvas, setCanvas] = useState(undefined);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <p
          className="titleChart"
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            width: "100%",
          }}
        >
          {props.title}
        </p>
        <DownloadButton canvas={canvas} fileName={"Chart"} csv={data} />
      </Box>
      <Chart
        padding={[15, 20, 50, 50]}
        height={300}
        data={dv}
        autoFit
        onGetG2Instance={(chartInstance) => {
          setTimeout(() => {
            setCanvas(chartInstance.canvas);
          }, 1000);
        }}
      >
        <Legend />
        <Coordinate transpose scale={[1, -1]} />
        <Axis
          name="year"
          label={{
            offset: 12,
            style: {
              fontFamily: "Roboto Condensed, sans-serif",
            },
          }}
        />
        <Axis
          label={{
            formatter: (a) => {
              return a + "%";
            },
          }}
          name="value"
          position={"right"}
        />
        <Tooltip shared>
          {(title, items) => {
            const data = transform.filter((t) => t["year"] === title);
            // const color = items[0].color;
            return (
              <div
                id="#tooltipWrap"
                style={{
                  padding: "5px 10px 10px 5px",
                  width: "auto",
                  color: "#22294D",
                  fontFamily: "Roboto Condensed",
                  opacity: "1",
                }}
              >
                <div
                  className="g2-tooltip-title"
                  style={{
                    fontSize: "medium",
                    paddingBottom: "0",
                    fontWeight: "bold",
                  }}
                >
                  {data[0]["year"]}
                </div>
                <ul className="g2-tooltip-list">
                  <li style={{ padding: "2px 0" }} data-index="0">
                    <span
                      style={{
                        backgroundColor: "#688E31",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    ≤MRL:{" "}
                    {data[0]["≤MRL"] === null
                      ? ""
                      : Math.round(data[0]["≤MRL"] * 10) / 10 + "%"}
                  </li>
                  <li style={{ padding: "2px 0" }} data-index="1">
                    <span
                      style={{
                        backgroundColor: "#F9B112",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    {'>'}MRL:{" "}
                    {data[1][">MRL"] === null
                      ? ""
                      : Math.round(data[1][">MRL"] * 10) / 10 + "%"}
                  </li>
                </ul>
              </div>
            );
          }}
        </Tooltip>
        <Interval
          position="year*value"
          color={["type", ["#688E31", "#F9B112"]]}
          adjust={[
            {
              type: "dodge",
              marginRatio: 1 / 32,
            },
          ]}
        />
      </Chart>
    </Box>
  );
};

export default DodgeBarCommodity;
